// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"792f0ecd","907":"8432bb10"}[chunkId] + ".chunk.css";
};